import React, { ForwardedRef, forwardRef, ReactElement } from "react";
import { Helmet } from "react-helmet";
import { Box, Theme } from "@mui/material";

interface Props {
  sx?: Record<string, string | number>;
  className?: string;
  children: ReactElement | ReactElement[];
  title?: string;
  noPad?: boolean;
  flexChildren?: boolean;
  rest?: any[];
}

const defaultStyles = {
  height: "100%",
  py: 4,
};

const Page = forwardRef(
  (
    {
      sx = defaultStyles,
      children,
      title = "",
      className = "",
      noPad = false,
      flexChildren = false,
      ...rest
    }: Props,
    ref: ForwardedRef<HTMLDivElement>
  ) => {
    const combinedClassName = className ? `${className} Page` : "Page";
    return (
      <Box sx={sx} className={combinedClassName} ref={ref} {...rest}>
        <Helmet>
          <title>{title}</title>
        </Helmet>
        <Box
          sx={{
            width: "100%",
            py: noPad ? 0 : 2,
            textAlign: "left",
            display: flexChildren ? "flex" : "block",
            "& a": {
              color: "text.primary",
              textDecoration: "underline",
              textDecorationStyle: "dashed",
              textDecorationColor: (theme: Theme) =>
                theme.palette.secondary.main,
              textUnderlinePosition: "under",
            },
            "& a:hover": {
              textDecorationStyle: "solid",
            },
          }}
        >
          {children}
        </Box>
      </Box>
    );
  }
);

export default Page;
